import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: '01ete',
      title: '01. Property Listing & Marketplace Development',
      intitle: 'Property Listing & Marketplace Development',
      icon: '/assets/svg/industries/realstate/r1.svg',
      content:
         'We create user-friendly real estate marketplaces that allow buyers, sellers, and agents to list, search, and manage properties through rich filters and AI-based recommendations. Our marketplaces include interactive property maps, 3D tours, and geolocation-based search filters for a rich user experience. We implement AI-powered recommendation engines, automated listing management, and dynamic pricing insights. With secure payment gateways, user verification, and real-time messaging, we enhance transparency and streamline property transactions.',
   },
   {
      id: '02ete',
      title: '02. Real Estate CRM Software Development',
      intitle: 'Real Estate CRM Software Development',
      icon: '/assets/svg/industries/realstate/r2.svg',
      content:
         'Our tailored CRM solutions assist real estate agencies in managing leads, customer interactions, automated follow-ups, and optimizing sales pipeline efficiency to achieve higher conversions. We design CRMs with lead scoring, automated email marketing, and tracking of multi-channel communications. Our systems feature live property status updates, document management, and automated tasks. Agencies can optimize client interaction, improve response times, and boost conversion rates with superior reporting and analytics.',
   },
   {
      id: '03ete',
      title: '03. Property Management Software',
      intitle: 'Property Management Software',
      icon: '/assets/svg/industries/realstate/r3.svg',
      content:
         'We create turnkey property management solutions that simplify rental payment collection, lease monitoring, maintenance request tracking, tenant screening, and financial reporting for property owners and managers. Our platforms include rent collection automation, lease agreement tracking, and tenant screening integration. We enable real-time maintenance ticketing, service provider coordination, and expense tracking. With detailed financial reports, custom dashboards, and automated reminders, property managers can optimize operations and reduce administrative overhead.',
   },
   {
      id: '04ete',
      title: '04. Real Estate Mobile App Development',
      intitle: 'Real Estate Mobile App Development',
      icon: '/assets/svg/industries/realstate/r4.svg',
      content:
         'Our feature-rich real estate mobile apps provide instant property searches, push notifications for new listings, mortgage calculators, and direct agent communication, enhancing customer engagement. We develop apps with AI-powered property recommendations, location-based search, and interactive map views. Our solutions include real-time chat, in-app scheduling, and document sharing for seamless agent-client interactions. With secure payment gateways and digital contract signing, we simplify property transactions on mobile devices.',
   },
   {
      id: '05ete',
      title: '05. AI-Powered Property Valuation & Predictive Analytics',
      intitle: 'AI-Powered Property Valuation & Predictive Analytics',
      icon: '/assets/svg/industries/realstate/r5.svg',
      content:
         'We look at past sales, current market trends, and a bunch of real data to help people figure out what a place is probably worth right now. We employ predictive analytics to predict property value movements, rental yield, and ROI potential. Our solutions integrate machine learning models to identify high-growth areas and market trends. With dynamic pricing algorithms, risk assessment, and investment forecasting, we empower smarter decision-making for real estate stakeholders.',
   },
   {
      id: '06ete',
      title: '06. Real Estate Auction & Bidding Software',
      intitle: 'Real Estate Auction & Bidding Software',
      icon: '/assets/svg/industries/realstate/r6.svg',
      content:
         'We develop secure online real estate auction platforms with live bidding, automated price calculations, and escrow integration, ensuring transparent and seamless transactions. Our platforms support real-time auction streaming, dynamic bidding interfaces, and instant notifications. We implement smart bidding algorithms, automated price adjustments, and fraud prevention measures. With escrow services, payment processing, and detailed bid history tracking, we enhance transaction security and transparency.',
   },
   {
      id: '07ete',
      title: '07. Smart Contract & Blockchain-Based Real Estate Solutions',
      intitle: 'Smart Contract & Blockchain-Based Real Estate Solutions',
      icon: '/assets/svg/industries/realstate/r7.svg',
      content:
         'Our real estate blockchain-based solutions support safe property transactions, digital contracts, fraud protection, and immediate ownership transfers through the application of smart contracts. We develop platforms with immutable property records, tokenized asset trading, and automated contract execution. Our solutions include KYC verification, digital escrow services, and transparent transaction history. With blockchain-based identity management and fractional ownership capabilities, we enhance trust and efficiency in real estate transactions.',
   },
]

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Advanced Real Estate Software Development Solutions
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               As one of the top real estate software development companies, we
               offer AI-based, scalable, and customized solutions to optimize
               property management, drive customer experiences, and enable real
               estate operations. Our latest technology provides a smooth
               buying, selling, and renting experience for businesses and
               individuals alike. Explore our comprehensive real estate software
               development services:
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
